export default {
  title: 'Recompensas',
  guest: {
    eyebrow: 'Recompensas',
    headline: 'Cada encomenda dá-lhe <highlight>recompensas</highlight>',
    subheading_one: 'Ganhe {{count}} ponto por cada {{amount}} gasto.',
    subheading_other: 'Ganhe {{count}} pontos por cada {{amount}} gasto.',
    cta: 'Registe-se e comece a ganhar',
    already_member: 'Já é membro?',
    sign_in: 'Iniciar sessão',
    redeemable_heading: 'Os seus pontos = comida grátis',
    redeemable_eyebrow: '🎁 Recompensas que vai desbloquear',
  },
  member: {
    balance_label: 'O seu saldo',
    balance_suffix: 'pontos · vale <highlight>{{amount}}</highlight>',
    next_reward: 'Próxima recompensa a <highlight>{{points}} pts</highlight>',
    redeem_hint: '✓ Pode resgatar até {{points}} pts ({{amount}}) na sua próxima encomenda',
    expiration_zero: '⏳ {{points}} pts expiram hoje',
    expiration_one: '⏳ {{points}} pts expiram em 1 dia',
    expiration_other: '⏳ {{points}} pts expiram em {{count}} dias',
    pts_lifetime: 'Pts totais',
    saved_lifetime: 'Total poupado',
    cta: 'Encomendar agora',
    redeemable_heading: 'O que pode resgatar',
    redeemable_eyebrow: 'Tem {{points}} pts ({{amount}})',
    redeemable_description:
      'Até {{maxPoints}} pts ({{maxAmount}}) por encomenda. Itens abaixo de {{maxAmount}} são completamente gratuitos.',
  },
  items: {
    free: 'GRÁTIS',
    save: 'Poupe {{amount}}',
  },
  history: {
    eyebrow: 'Histórico',
    title: 'Atividade recente',
    load_more: 'Carregar mais',
    sources: {
      welcome_bonus: 'Bónus de boas-vindas',
      google_review_reward: 'Recompensa por avaliação Google',
      reward_loyalty_program_conversion: 'Conversão de programa de fidelidade',
      cashback: 'Cashback obtido',
      refund: 'Pedido reembolsado',
      cashback_usage: 'Pontos utilizados',
      cashback_usage_refund: 'Resgate reembolsado',
      expired_points_void: 'Pontos expirados',
      mobile_app_signup_bonus: 'Bónus de registo na app',
    },
    detail_with_order: 'Pedido #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Simples e Automático',
    eyebrow_member: 'Lembrete rápido',
    title: 'Como funciona',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Registo gratuito',
        desc: 'Crie uma conta em 30 segundos.',
      },
      order: {
        emoji: '🍔',
        title: 'Peça e ganhe',
        desc_one: '1 pt por {{amount}} — registado automaticamente.',
        desc_other: '{{count}} pts por {{amount}} — registado automaticamente.',
      },
      build: {
        emoji: '⭐',
        title: 'Acumule pontos',
        desc: 'Utilize a partir de {{minPoints}} pts. Válidos por {{lifetime}} dias.',
      },
      save: {
        emoji: '🎁',
        title: 'Poupe no checkout',
        desc: 'Até {{maxAmount}} de desconto — aplicado de imediato.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Repita e poupe',
        desc: 'Cada pedido aumenta o seu saldo.',
      },
    },
  },
  faq: {
    eyebrow: 'Dúvidas?',
    title: 'Perguntas frequentes',
    items: {
      earn: {
        q: 'Como ganho pontos?',
        a_one:
          'Ganha 1 ponto por cada {{amount}} que gasta. Os pontos são adicionados automaticamente à sua conta após cada pedido — sem necessidade de leituras ou códigos.',
        a_other:
          'Ganha {{count}} pontos por cada {{amount}} que gasta. Os pontos são adicionados automaticamente à sua conta após cada pedido — sem necessidade de leituras ou códigos.',
      },
      redeem: {
        q: 'Quando posso começar a utilizar os pontos?',
        a: 'Pode começar a utilizar os pontos quando atingir {{minPoints}} pontos. Use-os no checkout para reduzir o total do pedido.',
      },
      max: {
        q: 'Quanto posso poupar por pedido?',
        a: 'Pode utilizar até {{maxPoints}} pontos ({{maxAmount}}) por pedido. Este é o desconto máximo que pode aplicar num único checkout.',
      },
      validity: {
        q: 'Por quanto tempo são válidos os pontos?',
        a: 'Os pontos são válidos por {{lifetime}} dias a contar da data em que foram ganhos. Use-os antes de expirarem!',
      },
    },
  },
};
